import auth from '@/modules/auth'
import menu from '@/modules/menu'
import employees from '@/modules/employees'
import utils from '@/modules/utils'
import ui from '@/modules/ui'
import ci from '@/modules/ci'

export default {
  auth,
  menu,
  employees,
  utils,
  ui,
  ci,
}
